var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('div',[_vm._v(" Neki kod "+_vm._s(_vm.code2)+" "),_c('v-img',{staticClass:"bg-white",attrs:{"aspect-ratio":1,"src":_vm.Canvas1,"width":"200","height":"100"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }